module.exports = __webpack_public_path__ + "img/divide&Conquer.92b9c408.svg";